import React, { Component } from 'react';
import ReactDOM from 'react-dom';

const slots = new Map();
const listeners = new Set();

function notify() {
  for (const cb of listeners) {
    try { cb(); } catch (err) { /* listener error */ }
  }
}

export class HeaderSlot extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    slots.set(this.props.id, this.ref.current);
    notify();
  }

  componentWillUnmount() {
    if (slots.get(this.props.id) === this.ref.current) {
      slots.delete(this.props.id);
      notify();
    }
  }

  render() {
    return <div ref={this.ref} className={this.props.className || ""}/>;
  }
}

export class HeaderSlotPortal extends Component {
  constructor(props) {
    super(props);
    this.state = { target: slots.get(props.targetId) || null };
  }

  componentDidMount() {
    this.unsubscribe = (() => {
      const cb = () => {
        const next = slots.get(this.props.targetId) || null;
        if (next !== this.state.target) {
          this.setState({ target: next });
        }
      };
      listeners.add(cb);
      return () => listeners.delete(cb);
    })();
    if (!this.state.target) {
      const target = slots.get(this.props.targetId) || null;
      if (target) {
        this.setState({ target });
      }
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    if (!this.state.target) {
      return null;
    }
    return ReactDOM.createPortal(this.props.children, this.state.target);
  }
}
